export function initShowMorePosts() {
  const showMoreButtons = document.querySelectorAll('[data-show-more-posts]');
  const articleHolder = document.getElementById('infinite-post-contents');

  if(!showMoreButtons.length || !articleHolder) {
    return;
  }

  for(let button of showMoreButtons) {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      if(articleHolder.classList.contains('is-loading')) {
        return;
      }

      getMorePosts();
    });
  }
}

export function getMorePosts(clearAll = false) {
  const articleHolder = document.getElementById('infinite-post-contents');
  const hasFilter = articleHolder?.dataset?.hasFilter;

  if(!articleHolder) {
    return;
  }

  if(!window.resources) {
    return;  
  }
  const api_url = new URL(`${window.resources.api_domain}/wp-json/resources/get-posts`);

  if(hasFilter) {
    api_url.searchParams.append("has_filter", 1);
  }

  if(window.resources?.post_types) {
    api_url.searchParams.append("post_types", window.resources.post_types.join(','));
  }

  if(window.resources?.terms) {
    api_url.searchParams.append("terms", window.resources.terms.join(','));
  }

  Object.keys(window.resources.tags).forEach((tag) => {
    if(window.resources.tags[tag]) {
      api_url.searchParams.append(tag, window.resources.tags[tag]);
    }
  });


  if(window.resources?.per_page) {
    api_url.searchParams.append("per_page", window.resources?.per_page);
  }

  api_url.searchParams.append("page", Number(window.resources?.page) + 1 || 2);
  window.resources.page = Number(window.resources?.page) + 1; 

  articleHolder.classList.add('is-loading');

  return fetch(api_url.href).then((response) => {
    return response.json();
  }).then((response) => {
    window.resources = {...window.resources, ...response.meta};
    
    if(clearAll) {
      articleHolder.innerHTML = response.posts || '<div class="flex-col- flex-col-12 text-center"><strong>No posts found</strong></div>';
      const scrollToEl = document.getElementById('page-content') || articleHolder;
      scrollToEl.scrollIntoView({behavior: 'smooth'});
    }
    else {
      articleHolder.innerHTML += response.posts || '';
    }

    const showMoreButtons = document.querySelectorAll('[data-show-more-posts]');
    for(let button of showMoreButtons) {
      if(!window.resources.post_count) {
        button.parentElement.classList.add('hidden');
      }
      else {
        button.parentElement.classList.remove('hidden');
      }
    }

    window.setTimeout(() => {

      const articles = articleHolder.querySelectorAll('.is-loading');
      for(let article of articles) {
        article.classList.remove('is-loading');
      }
    }, 300);

    articleHolder.classList.remove('is-loading');
  });
}